import React from 'react';

const LinkedinIcon = () => {
    return (
        <>
             <svg
                  width="35"
                  height="35"
                  viewBox="0 0 59 59"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2734_17489)">
                    <path
                      d="M36.333 23.3185C38.8526 23.3185 41.2689 24.3194 43.0505 26.101C44.8321 27.8826 45.833 30.2989 45.833 32.8185V43.9015H39.5V32.8185C39.5075 32.3979 39.4311 31.9801 39.2753 31.5893C39.1196 31.1986 38.8875 30.8428 38.5927 30.5428C38.2979 30.2427 37.9463 30.0044 37.5585 29.8417C37.1706 29.679 36.7541 29.5952 36.3335 29.5952C35.9129 29.5952 35.4965 29.679 35.1086 29.8417C34.7207 30.0044 34.3691 30.2427 34.0743 30.5428C33.7795 30.8428 33.5475 31.1986 33.3917 31.5893C33.2359 31.9801 33.1595 32.3979 33.167 32.8185V43.9015H26.833V32.8185C26.833 30.2989 27.8339 27.8826 29.6155 26.101C31.3971 24.3194 33.8135 23.3185 36.333 23.3185Z"
                      stroke="url(#paint0_linear_2734_17489)"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M20.5 24.9015H14.167V43.9015H20.5V24.9015Z"
                      stroke="url(#paint1_linear_2734_17489)"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.3334 20.1515C17.7539 20.159 18.1718 20.0826 18.5625 19.9268C18.9532 19.771 19.309 19.539 19.6091 19.2442C19.9091 18.9494 20.1475 18.5978 20.3102 18.2099C20.4729 17.822 20.5567 17.4056 20.5567 16.985C20.5567 16.5644 20.4729 16.1479 20.3102 15.76C20.1475 15.3722 19.9091 15.0206 19.6091 14.7258C19.309 14.431 18.9532 14.199 18.5625 14.0432C18.1718 13.8874 17.7539 13.811 17.3334 13.8185C16.5033 13.8332 15.7122 14.1733 15.1304 14.7656C14.5486 15.3578 14.2227 16.1548 14.2227 16.985C14.2227 17.8152 14.5486 18.6122 15.1304 19.2044C15.7122 19.7966 16.5033 20.1367 17.3334 20.1515Z"
                      stroke="url(#paint2_linear_2734_17489)"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_2734_17489"
                      x1="30.1572"
                      y1="10.9871"
                      x2="46.1307"
                      y2="63.1724"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#1F8D82" />
                      <stop offset="1" stopColor="#88C5BF" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_2734_17489"
                      x1="15.275"
                      y1="13.5185"
                      x2="41.262"
                      y2="44.1745"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#1F8D82" />
                      <stop offset="1" stopColor="#88C5BF" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_2734_17489"
                      x1="15.3308"
                      y1="10.0233"
                      x2="19.9265"
                      y2="26.2883"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#1F8D82" />
                      <stop offset="1" stopColor="#88C5BF" />
                    </linearGradient>
                    <clipPath id="clip0_2734_17489">
                      <rect
                        width="59"
                        height="59"
                        fill="white"
                        transform="translate(0 -0.348511)"
                      />
                    </clipPath>
                  </defs>
                </svg>
        </>
    );
};

export default LinkedinIcon;